import {
  DataGrid,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  ptBR,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import InsertLinkRoundedIcon from '@mui/icons-material/InsertLinkRounded';
import LinkOffRoundedIcon from '@mui/icons-material/LinkOffRounded';
import Box from "@mui/material/Box";
import PublishRoundedIcon from '@mui/icons-material/PublishRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

export const DataGridTracker = ({
  loadingData,
  data,
  columns,
  editMode,
  pageSize,
  rowsPerPageOptions,
  deleteRecord,
  linkRecord,
  unLinkRecord,
  sendCommandTrackerDialogOpen,
  files,
  devicesId,
}) => {
  const [rows, setRows] = useState(data);
  const [rowModesModel, setRowModesModel] = useState({});
  const [clickedCheckBox, setClickedCheckBox] = useState(false);

  useEffect(() => {
    if (data) {
      data.forEach((element2) => {
        element2.version = [];
        files.forEach((element1) => {
          element2.version.push(element1.version);
        });
      });
    }
    setRows(data);
  }, [data]);

  const columnsWithActions = columns.concat({
    field: "actions",
    type: "actions",
    headerName: "",
    cellClassName: "actions",
    width: 200,
    editable: false,
    headerAlign: "center",
    align: "center",
    getActions: ({ id }) => {
      if (
        data.find((t) => t.id === id).companyId !==
        "00000000-0000-0000-0000-000000000000"
      ) {
        return [
          <GridActionsCellItem
            title={"Desassociar"}
            icon={<LinkOffRoundedIcon />}
            label="Desassociar"
            className="textPrimary"
            onClick={handleUnlinkClick(id)}
            color="inherit"
            sx={{ color: 'rgb(15, 75, 116)', ':hover': { backgroundColor: 'rgb(193, 217, 245)' } }}
          />,
          <GridActionsCellItem
            title={"Enviar Comandos"}
            icon={<PublishRoundedIcon />}
            label="Enviar Comandos"
            className="textPrimary"
            onClick={handleSave(id)}
            color="inherit"
            sx={{ color: 'rgb(29, 148, 11)', ':hover': { backgroundColor: 'rgb(193, 245, 193)' } }}
          />,
          <GridActionsCellItem
            title={"Deletar"}
            icon={<DeleteRoundedIcon />}
            label="Deletar"
            onClick={handleDeleteClick(id)}
            color="inherit"
            sx={{ color: 'red', ':hover': { backgroundColor: 'rgb(250, 219, 219)' } }}
          />,
        ];
      } else {
        return [
          <GridActionsCellItem
            title={"Associar"}
            icon={<InsertLinkRoundedIcon />}
            label="Associar"
            className="textPrimary"
            onClick={handleLinkClick(id)}
            color="inherit"
            sx={{ color: 'rgb(15, 75, 116)', ':hover': { backgroundColor: 'rgb(193, 217, 245)' } }}
          />,
          <GridActionsCellItem
            title={"Enviar Comandos"}
            icon={<PublishRoundedIcon />}
            label="Enviar Comandos"
            className="textPrimary"
            onClick={handleSave(id)}
            color="inherit"
            sx={{ color: 'rgb(29, 148, 11)', ':hover': { backgroundColor: 'rgb(193, 245, 193)' } }}
          />,
          <GridActionsCellItem
            title={"Deletar"}
            icon={<DeleteRoundedIcon />}
            label="Deletar"
            onClick={handleDeleteClick(id)}
            color="inherit"
            sx={{ color: 'red', ':hover': { backgroundColor: 'rgb(250, 219, 219)' } }}
          />,
        ];
      }
    },
  });

  const handleLinkClick = (id) => () => {
    linkRecord(id);
  };

  const handleUnlinkClick = (id) => () => {
    unLinkRecord(id);
  };

  const handleDeleteClick = (id) => () => {
    deleteRecord(id);
  };

  const handleSave = (id) => () => {
    sendCommandTrackerDialogOpen(id);
  };

  const processRowUpdate = (newRow) => { };

  const processRowUpdateError = (err) => { };

  const onDeviceSelectionHandler = (id) => {
    const selectedRows = id.map((id) => rows.find((row) => row.id === id));
    const deviceIds = selectedRows.map((row) => row.deviceId);
    devicesId(deviceIds);
    setClickedCheckBox(true);

  };


  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton
          title="Exibir Colunas"
          sx={{ color: "#414141" }}
          size="20px"
        />
        <GridToolbarFilterButton
          componentsProps={{ button: { variant: "outlined" } }}
          title="Selecionar Filtros"
          sx={{ color: "#414141" }}
          size="20px"
        />
        <GridToolbarDensitySelector
          title="Espessura das linhas"
          sx={{ color: "#414141" }}
          size="20px"
        />
        <GridToolbarExport sx={{ color: "#414141" }} size="20px" />
      </GridToolbarContainer>
    );
  }

  const configComponentsProps = {
    panel: {
      sx: {
        "& .MuiTypography-root": {
          color: "#2f3237",
          fontSize: 12,
        },

        "& .MuiSvgIcon-root": {
          color: "#2f3237",
          marginTop: "-1px",
        },
        "& .batteryTrunk": {
          marginTop: "-1px",
          color: "#2f3237",
        },
        "& .svg-inline--fa": {
          marginTop: "-1px",
          color: "#2f3237",
        },
        "& .MuiDataGrid-columnsPanelRow:first-of-type": {
          display: "none",
        },
        "& .MuiDataGrid-panelFooter button:first-of-type": {
          display: "none",
        },
      },
    },
    footer: {
      sx: {
        "& .MuiTablePagination-root": {
          minHeight: "30px",
          height: "30px",
        },
        "& .MuiTablePagination-toolbar": {
          marginTop: "5px",
          minHeight: "10px",
          height: "10px",
        },
        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
        {
          fontSize: "12px",
          margin: 0,
          color: "black !important",
        },
        "& .MuiTablePagination-select": {
          margin: 0,
          fontSize: "12px",
        },
        "& .MuiTablePagination-actions": {
          margin: 0,
        },
        "& .css-rtrcn9-MuiTablePagination-root:last-child": {
          display: "contents",
        },
      },
    },
  };

  return (
    <Box
      sx={{
        height: '60vh',
        width: "100%",
        "& .dataGrid-true": {
          bgcolor: "#eeeeee",
        },
        "& .dataGrid-false": {
          bgcolor: "#ffffff",
        },
      }}
    >
      <DataGrid
        loading={loadingData}
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        components={{
          Toolbar: CustomToolbar,
        }}
        rows={rows}
        rowHeight={60}
        columns={columnsWithActions}
        rowModesModel={rowModesModel}
        editMode={editMode ?? "row"}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={processRowUpdateError}
        pageSize={pageSize ?? 10}
        density={'compact'}
        rowsPerPageOptions={rowsPerPageOptions ?? [5]}
        checkboxSelection={true}
        onSelectionModelChange={(id) => onDeviceSelectionHandler(id)}
        experimentalFeatures={{ newEditingApi: true }}
        getRowClassName={(params) =>
          `dataGrid-${params.row.isRemoved ? "true" : "false"}`
        }
        componentsProps={configComponentsProps}
        disableSelectionOnClick
      />
    </Box>
  );
};
